import { render, staticRenderFns } from "./ItemProductSelected.vue?vue&type=template&id=1795b2c2&scoped=true&"
import script from "./ItemProductSelected.vue?vue&type=script&lang=js&"
export * from "./ItemProductSelected.vue?vue&type=script&lang=js&"
import style0 from "./ItemProductSelected.vue?vue&type=style&index=0&id=1795b2c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1795b2c2",
  null
  
)

export default component.exports